import React from 'react';
import { xcss, Pressable, type PressableProps } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export const StyledButton = (props: PressableProps) => (
	<Pressable {...props} xcss={pressableStyles} />
);

StyledButton.displayName = 'StyledButton';

const pressableStyles = xcss({
	height: '40px',
	width: '40px',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
	borderRadius: token('radius.small', '3px'),
	':hover': {
		background: token('color.background.neutral.hovered'),
	},
	':active': {
		background: token('color.background.neutral.pressed'),
	},
});
